// 原ae
export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2:
      return splitKey[1]

    case splitKey.length === 3 && splitKey[2].length >= 5:
      return splitKey[2]

    case splitKey.length === 3 && splitKey[2].length < 5:
      return splitKey[0]

    default:
      return splitKey[3]
  }
}
